<template>
  <div
    class="mx-auto window win-card draggable resizable"
    style="position: fixed; top: 300px; left: 800px; height: auto; width: 400px;"
    v-if="open"
    @click="$emit('toFront')"
  >
    <WindowBar
      title="Contact me!"
      @close="$emit('close')"
      @maximize="maximized=true"
      @minimize="maximized=false"
    />
    <div v-show="maximized" class="contact-content">
      <div class="contact-row">
        <div class="contact-col">
          <button class="contact-link-btn" @click="openUrl('https://linkedin.com/in/oliverclark15')">
            LinkedIn <span class="mdi mdi-linkedin"></span>
          </button>
        </div>
        <div class="contact-col">
          <button class="contact-link-btn" @click="openUrl('https://github.com/olicla')">
            GitHub <span class="mdi mdi-github"></span>
          </button>
        </div>
        <div class="contact-col">
          <button class="contact-link-btn" @click="open('mailto:oliverclark15@gmail.com')">
            Email <span class="mdi mdi-email"></span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import WindowBar from './WindowBar.vue'

export default {
  name: "ContactNE",
  data: () => ({
    open: true,
    maximized: true,
  }),
  components: {
    WindowBar
  },
  methods: {
    openUrl(url) {
      window.open(url, '_blank');
    }
  }
};
</script>

<style src="98.css"></style>
<style scoped>
.contact-content {
  padding: 16px;
}

.contact-row {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.contact-col {
  padding: 4px;
  width: 100%;
  display: flex;
  justify-content: center;
}

.contact-link-btn {
  width: 100%;
  max-width: 200px;
  cursor: pointer;
}
</style>
